/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// document.addEventListener("DOMContentLoaded", function () {
//   const amazonCheckbox = document.getElementById("amazon-display-checkbox");
//   const amazonContent = document.querySelector(".p-cf__amazon");

//   amazonCheckbox.addEventListener("change", function () {
//     if (amazonCheckbox.checked) {
//       amazonContent.style.display = "block";
//     } else {
//       amazonContent.style.display = "none";
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const cartDrawer = document.querySelector("#CartContainer"); // ドロワーカートの親要素のセレクターを適宜設定

//   // ドロワーカート内のチェックボックスの変更イベントを委任
//   cartDrawer.addEventListener("change", function (event) {
//     if (event.target.id === "amazon-display-checkbox") {
//       const amazonContent = cartDrawer.querySelector(".p-cf__amazon");
//       if (amazonContent) {
//         amazonContent.style.display = event.target.checked ? "block" : "none";
//       }
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // 処理を実行する関数
  const initializeCheckboxLogic = () => {
    const configurations = [
      {
        checkboxId: "cart-agree",
        buttonId: "checkout-button",
      },
      {
        checkboxId: "ajaxcart-agree",
        buttonId: "ajax-checkout-button",
      },
    ];

    configurations.forEach(({ checkboxId, buttonId }) => {
      const checkbox = document.getElementById(checkboxId);
      const button = document.getElementById(buttonId);

      if (checkbox && button) {
        // 初期状態の設定
        button.disabled = !checkbox.checked;

        // チェックボックスの状態が変わったときの処理
        checkbox.addEventListener("change", function () {
          button.disabled = !this.checked;
        });
      }
    });
  };

  // 1.5秒後に処理を開始
  setTimeout(initializeCheckboxLogic, 1500);
});
